<template>
    <v-card>
        <v-card-text fluid>
            <v-data-table :headers="dTable.headers" :items="dPriAlumnoDocs" :loading="dTable.loading" class="elevation-1" hide-default-footer>
                <template v-slot:no-data>
                    <v-alert :value="true" type="warning" text border="top">
                        <strong>No hay registros para mostrar.</strong>
                    </v-alert>
                </template>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>DOCUMENTOS</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical ></v-divider>
                        <v-btn color="primary" @click="fuModal()"><v-icon>add</v-icon> Agregar</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn @click="fuModalDelete(item.documento)" title="Eliminar" text><v-icon>cancel</v-icon> Eliminar</v-btn>
                </template>
                <template v-slot:[`item.enlace`]="{ item }">
                    <a :href="item.enlace" target="_blank" rel="noopener noreferrer"><v-icon color="primary" left>text_snippet</v-icon>{{item.documento}}</a>
                </template>
            </v-data-table>
        </v-card-text>
        <v-navigation-drawer
            v-model="dModal.dialog"
            right
            temporary
            fixed
            width="400"
        >
            <v-list-item class="text-h5 blue-grey" dark>
                <v-list-item-content>
                    <v-list-item-title class="text-h6">Agregar Documento</v-list-item-title>
                </v-list-item-content>                
                <v-btn icon @click="dModal.dialog = false"><v-icon>close</v-icon></v-btn>
            </v-list-item>
            <v-divider></v-divider>
            <div class="pa-2">
                <v-form ref="refModal">
                    <v-row dense>
                        <v-col cols="12" xm="12" class="pa-1">
                            <v-select v-model="dSelectedTipo" label="* Tipo de documento" :items="dTipo" :disabled="dTable.loading" filled prepend-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                        </v-col>
                        <v-col cols="12" xm="12" class="pa-1">
                            <v-file-input v-model="dSelectedFile" label="Seleccionar documento" filled :rules="[v => !!v || 'El campo es requerido']"></v-file-input>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-btn @click="fuModalSave" :loading="dTable.loading" :disabled="!dSelectedFile?true:false && !dSelectedTipo?true:false" color="primary" block><v-icon>save</v-icon> Guardar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
        </v-navigation-drawer>
    </v-card>
</template>
<script>
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    name: 'PriAlumnoDocs',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        }
    },
    mounted(){
        if (this.pIdAlumno)
            this.fuAlumnoDocs();
    },
    data: () => ({
        dModal: {
            dialog: false,
            loading: false,
        },
        dTable: {
            headers: [
                { text: 'Enlace', value: 'enlace', sortable: false },
                { text: 'Acciones', value: 'actions', sortable: false },
            ],
            loading: false,
        },
        dPriAlumnoDocs: [],
        dTipo: [],
        dSelectedFile: null,
        dSelectedTipo: null,
    }),
    methods: {
        async fuAlumnoDocs() {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query tlDocsByAlumno($IdAlumno: ID!, $token: String){
                        tlDocsByAlumno(IdAlumno:$IdAlumno, token: $token)
                    }`,
                    variables: {
                        IdAlumno: this.pIdAlumno,
                        token: new Date().toISOString()
                    },
                    fetchPolicy: 'network-only'
                })
                const data = response.data.tlDocsByAlumno;
                if (data && typeof data === 'object') {
                    this.dPriAlumnoDocs = Object.entries(data).map(([nombre, url]) => ({
                        documento: nombre,
                        enlace: url
                    }));
                }
            } catch (error) {
                const isObjectError = error.graphQLErrors && 
                                    error.graphQLErrors.some(e => e.debugMessage && e.debugMessage.includes('IsObject'));
                if (isObjectError) {
                    console.warn("El backend devolvió [] en lugar de {}. Se asume lista vacía.");
                } else {
                    Swal.fire('¡ ERROR !', 'Problema al listar los documentos.', 'error');
                }
            } finally {                
                this.dTable.loading = false;
                const listaOriginal = ['DNI', 'CERTIFICADO DE ESTUDIO', 'CONSTANCIA DE ESTUDIO','DECLARACION JURADA','PARTIDA DE NACIMIENTO','FOTO'];
                const aQuitar = this.dPriAlumnoDocs.map(item => item.documento);
                this.dTipo = listaOriginal.filter(elemento => !aQuitar.includes(elemento));
            }
        },
        fuModal(){
            this.dModal.dialog = true;
            this.dSelectedTipo = null;
            this.dSelectedFile = null;
        },
        async fuModalSave(){
            if(this.$refs.refModal.validate()){
                this.dTable.loading = true;
                try {
                    const data= {
                        type: this.dSelectedTipo,
                        file: this.dSelectedFile
                    };
                    const response = await this.$apollo.mutate({
                        mutation: gql`mutation prialumnoUploadDocs($IdAlumno: ID!, $file: uploadDocAlumno!){
                            prialumnoUploadDocs(IdAlumno: $IdAlumno, file: $file) {
                                data
                                message
                                success
                            },
                        }`,
                        variables: {
                            IdAlumno: this.pIdAlumno,
                            file: data,
                        }
                    });
                    if(!response.data.prialumnoUploadDocs.success)
                        Swal.fire('¡ ERROR !', response.data.prialumnoUploadDocs.message, 'error');
                    else {
                        this.fuAlumnoDocs();
                        Swal.fire('Correcto', 'Registro correcto.', 'success');                        
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                } finally {
                    this.dTable.loading = false;
                    this.dModal.dialog = false;
                }
            }
        },
        async fuModalDelete(pKey){
            try {
                Swal.fire({
                    icon: 'question',
                    title: '¿Estás seguro de ELIMINAR?',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, eliminar',
                    cancelButtonText: 'No',
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                    preConfirm: (login) => {
                        return this.$apollo.mutate({
                            mutation: gql`mutation prialumnoDropDoc($IdAlumno: ID!, $key: String!){
                                mutation1: prialumnoDropDoc(IdAlumno: $IdAlumno, key: $key){
                                    data
                                },
                            }`,
                            variables: {
                                IdAlumno: this.pIdAlumno,
                                key: pKey,
                            }
                        });
                    },
                }).then((result) => {
                    if (result.value){
                        this.fuAlumnoDocs(this.pIdAlumno);
                    }
                })                
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error al eliminar el documento.', 'error');
            }
        }
    }
}
</script>
<style scoped>
    .v-data-table tbody tr:nth-of-type(even) {
        background-color: #f5f5f5; /* Un gris muy claro */
    }

    .v-data-table tbody tr:nth-of-type(even):hover {
        background-color: #eeeeee !important;
    }
</style>
